export default __webpack_public_path__ + "static/media/logo_color.1abbc6c1.svg";